module.exports = __webpack_public_path__ + "static/media/bars.5bb312dc.svg";